import { productCategoryList } from "constants/productCategories";

const initialState = {
  productCategoryList: {},
};

const productCategory = (state = initialState, action) => {
  switch (action.type) {
    case productCategoryList:
      return { ...state, productCategoryList: action.payload };
    default:
      return state;
  }
};

export default productCategory;